import { configureStore } from '@reduxjs/toolkit'
import { UserDataReducer } from './reducer';
import { UserDataSlice } from './userdata.slice';
export const store = configureStore({
    reducer: {
        UserDataReducer: UserDataSlice.reducer
    }
});